import { createContext as createContext } from 'react';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_animationsDisabledContext() {
  _init_properties_AnimationsDisabledContext_kt__6b5cfm();
  return animationsDisabledContext;
}
var animationsDisabledContext;
function get_thirdPartyAvatarsDisabledContext() {
  _init_properties_AnimationsDisabledContext_kt__6b5cfm();
  return thirdPartyAvatarsDisabledContext;
}
var thirdPartyAvatarsDisabledContext;
var properties_initialized_AnimationsDisabledContext_kt_4ybmb0;
function _init_properties_AnimationsDisabledContext_kt__6b5cfm() {
  if (!properties_initialized_AnimationsDisabledContext_kt_4ybmb0) {
    properties_initialized_AnimationsDisabledContext_kt_4ybmb0 = true;
    var tmp0 = createContext(false);
    // Inline function 'seskar.react.internal.withDisplayName' call
    var displayName = 'animationsDisabledContext';
    if (process.env.NODE_ENV !== 'production') {
      // Inline function 'kotlin.js.asDynamic' call
      if (!tmp0.displayName) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp0.displayName = displayName;
      }
    }
    animationsDisabledContext = tmp0;
    var tmp0_0 = createContext(false);
    // Inline function 'seskar.react.internal.withDisplayName' call
    var displayName_0 = 'thirdPartyAvatarsDisabledContext';
    if (process.env.NODE_ENV !== 'production') {
      // Inline function 'kotlin.js.asDynamic' call
      if (!tmp0_0.displayName) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp0_0.displayName = displayName_0;
      }
    }
    thirdPartyAvatarsDisabledContext = tmp0_0;
  }
}
//region block: exports
export {
  get_animationsDisabledContext as get_animationsDisabledContext3fr5r59ljcoug,
  get_thirdPartyAvatarsDisabledContext as get_thirdPartyAvatarsDisabledContextbdytsxs1lpoe,
};
//endregion

//# sourceMappingURL=AnimationsDisabledContext.mjs.map
